import type { SVGProps } from 'react';

const SvgFaceRecognition = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4 9.027c.55 0 1-.45 1-1v-2c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-1.65 0-3 1.35-3 3v2c0 .55.45 1 1 1m4 10H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.65 1.35 3 3 3h2c.55 0 1-.45 1-1s-.45-1-1-1m12-4c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c1.65 0 3-1.35 3-3v-2c0-.55-.45-1-1-1m-2-12h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.65-1.35-3-3-3m-2.91 13.41c.17.37.53.59.91.59a1 1 0 0 0 .91-1.41c-.39-.87-1-1.6-1.74-2.18.51-.67.82-1.5.82-2.41 0-2.21-1.79-4-4-4s-4 1.79-4 4c0 .91.31 1.73.82 2.41a5.9 5.9 0 0 0-1.74 2.18c-.23.5 0 1.1.5 1.32a.99.99 0 0 0 1.32-.5c.33-.73.88-1.32 1.55-1.72.47.2.99.31 1.54.31s1.06-.11 1.54-.31c.68.4 1.23.99 1.55 1.72zM10 11.027c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
    />
  </svg>
);
export default SvgFaceRecognition;
